export default __webpack_public_path__ + "static/media/step-2.ceec3e25.mp4";